<div class="container fonte-acessibilidade">
  <div [ngClass]="login.contraste ? 'card-panel mt-5 fundo-contraste' : 'card-panel mt-5 fundo-normal'">
    <div class="row">
      <div class="col-12">
        <a [routerLink]="['/transparencia/portal']" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="30" width="30">
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <header>
          <h5 class="fonte-acessibilidade">
            Presidência da República
          </h5>
          <h6 class="fonte-acessibilidade">
            Casa Civil
          </h6>
          <h6 class="fonte-acessibilidade">
            Subchefia para Assuntos Jurídicos
          </h6>
        </header>
        <p align="CENTER">
          <a href="http://legislacao.planalto.gov.br/legisla/legislacao.nsf/Viw_Identificacao/DEC%205.482-2005?OpenDocument"
            style="color: rgb(0,0,128)">
            <font color="#000080" face="Arial">
              <small>
                <strong class="fonte-acessibilidade">
                  DECRETO Nº 5.482, DE 30 DE JUNHO DE 2005.
                </strong>
              </small>
            </font>
          </a>
        </p>
        <table border="0" cellpadding="0" cellspacing="0" height="30" width="100%">
          <tbody>
            <tr>
              <td height="30" width="50%">
              </td>
              <td height="30" width="50%">
                <p style="text-align: justify">
                  <font color="#800000" face="Arial" size="2" class="fonte-acessibilidade">
                    Dispõe sobre a divulgação de dados e informações pelos órgãos e entidades da administração pública
                    federal, por meio da Rede Mundial de Computadores - Internet.
                  </font>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <font face="Arial" size="2">
          <p align="JUSTIFY">
            <strong class="fonte-acessibilidade">
              O PRESIDENTE DA REPÚBLICA,
            </strong>
            no uso da atribuição que lhe confere o art. 84, inciso VI, alínea "a", da Constituição,
          </p>
          <p align="JUSTIFY">
            <strong class="fonte-acessibilidade">
              DECRETA :
            </strong>
          </p>
          <p align="JUSTIFY" class="fonte-acessibilidade">
            Art. 1º
            O Portal da Transparência do Poder Executivo Federal, sítio eletrônico à disposição na Rede Mundial de
            Computadores - Internet, tem por finalidade veicular dados e informações detalhados sobre a execução
            orçamentária e financeira da União, compreendendo, entre outros, os seguintes procedimentos:
          </p>
          <p align="JUSTIFY" class="fonte-acessibilidade">
            I - gastos efetuados por órgãos e entidades da administração pública federal;
          </p>
          <p align="JUSTIFY" class="fonte-acessibilidade">
            II - repasses de recursos federais aos Estados, Distrito Federal e Municípios;
          </p>
          <p align="JUSTIFY" class="fonte-acessibilidade">
            III - operações de descentralização de recursos orçamentários em favor de pessoas naturais ou de
            organizações não-governamentais de qualquer natureza; e
          </p>
          <p align="JUSTIFY" class="fonte-acessibilidade">
            IV - operações de crédito realizadas por instituições financeiras oficiais de fomento.
          </p>
          <p align="JUSTIFY" class="fonte-acessibilidade">
            § 1º
            A Controladoria-Geral da União, como órgão central do Sistema de Controle Interno do Poder Executivo
            Federal, fica incumbida da gestão do Portal da Transparência.
          </p>
          <p align="JUSTIFY" class="fonte-acessibilidade">
            § 2º
            Os órgãos e entidades da administração pública federal deverão fornecer à Controladoria-Geral da União, até
            o décimo quinto dia do mês subseqüente ao da execução orçamentária, os dados necessários para a plena
            consecução dos objetivos do Portal da Transparência.
          </p>
          <p align="JUSTIFY" class="fonte-acessibilidade">
            Art. 2º
            Os órgãos e entidades da administração pública federal, direta e indireta, deverão manter em seus
            respectivos sítios eletrônicos, na Rede Mundial de Computadores - Internet, página denominada Transparência
            Pública, para divulgação, de dados e informações relativas à sua execução orçamentária e financeira,
            compreendendo, entre outras, matérias relativas a licitações, contratos e convênios.
          </p>
          <p align="JUSTIFY" class="fonte-acessibilidade">
            Parágrafo único. A Controladoria-Geral da União e o Ministério do Planejamento, Orçamento e Gestão
            disciplinarão, mediante portaria interministerial, publicada no prazo de sessenta dias a contar da edição
            deste Decreto, o conteúdo mínimo que deverá constar de cada página, bem como estabelecerá o cronograma de
            execução das ações de divulgação, consideradas as peculiaridades de cada órgão ou entidade.
          </p>
          <p align="JUSTIFY" class="fonte-acessibilidade">
            Art. 3º
            O acesso à pagina Transparência Pública prevista no art. 2º dar-se-á, necessariamente, por meio de atalho
            inserido na página inicial do sítio eletrônico dos respectivos órgãos ou entidades.
          </p>
          <p align="JUSTIFY" class="fonte-acessibilidade">
            Art. 4º
            As disposições deste Decreto não se aplicam aos dados e às informações de que trata o art. 1º , cujo sigilo
            seja ou permaneça imprescindível à segurança da sociedade e do Estado, nos termos da legislação.
          </p>
          <p align="JUSTIFY" class="fonte-acessibilidade">
            Art. 5º
            Os órgãos integrantes do Sistema de Controle Interno do Poder Executivo Federal verificarão o cumprimento do
            disposto neste Decreto.
          </p>
          <p align="JUSTIFY" class="fonte-acessibilidade">
            Art. 6º
            Este Decreto entra em vigor na data de sua publicação.
          </p>
          <p class="fonte-acessibilidade">
            Brasília, 30 de junho de 2005; 184º
            da Independência e 117º
            da República.
          </p>
          <p class="fonte-acessibilidade">
            LUIZ INÁCIO LULA DA SILVA
            <br />
            <i class="fonte-acessibilidade">
              Waldir Pires
            </i>
          </p>
          <p>
            <font color="#FF0000" face="Arial" size="2" class="fonte-acessibilidade">
              Este texto não substitui o publicado no D.O.U. de
            </font>
            <font color="#FF0000" class="fonte-acessibilidade">
              1º
            </font>
            <font color="#FF0000" face="Arial" size="2" class="fonte-acessibilidade">
              .
            </font>
            <font color="#FF0000" class="fonte-acessibilidade">
              7
            </font>
            <font color="#FF0000" face="Arial" size="2" class="fonte-acessibilidade">
              .2005
            </font>
          </p>
        </font>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <a class="fonte-acessibilidade" href="http://www.planalto.gov.br/ccivil_03/_Ato2004-2006/2005/Decreto/D5482.htm">Clique aqui para acessar o
          texto original</a>
      </div>
    </div>
  </div>
</div>
